import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "./BalanceManagement.scss";

interface IBalanceManagement {
  page: string;
}

const BalanceManagement = ({ page }: IBalanceManagement) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const account = searchParams.get("account") || "";
  const [modalActive, setModalActive] = useState(false);
  const handleOpenModal = () => {
    setModalActive((prev) => !prev);
  };

  useEffect(() => {
    if (account === "balance") {
      setModalActive(true);
    } else {
      setModalActive(false);
    }
  }, []);

  return (
    <div className={`user-profile-nav ${modalActive ? "active" : ""}`}>
      <div className="user-profile-nav-header" onClick={handleOpenModal}>
        <i className="user-profile-nav-icon bc-i-balance-management" />
        <span className="user-profile-nav-title">
          {t("admin.BalanceManagement")}
        </span>
        <i className="  count-blink-even " data-badge="" />
        <i
          className={`user-profile-nav-arrow bc-i-small-arrow-${
            modalActive ? "up" : "down"
          }`}
        />
      </div>
      <div className="user-profile-nav-list">
        <Link
          className={`user-profile-nav-item ellipsis ${
            page === "deposit" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=balance&page=deposit",
          }}
        >
          {t("admin.Deposit")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
        <Link
          className={`user-profile-nav-item ellipsis ${
            page === "withdraw" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=balance&page=withdraw",
          }}
        >
          {t("admin.Withdraw")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
        <Link
          className={`user-profile-nav-item ellipsis ${
            page === "history" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=balance&page=history",
          }}
        >
          {t("admin.TransactionHistory")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
        <Link
          className={`user-profile-nav-item ellipsis ${
            page === "withdraws" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=balance&page=withdraws",
          }}
        >
          {t("admin.WithdrawStatus")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
        <Link
          className={`user-profile-nav-item ellipsis ${
            page === "buddy-transfer" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=balance&page=buddy-transfer",
          }}
        >
          {t("admin.BuddyTransfer")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
        <div className="user-profile-nav-item-cursor user-profile-cursor-visible" />
      </div>
    </div>
  );
};

export { BalanceManagement };
